import TextContainer from "@client/content/Containers/Text/container";
import { ImageEntity } from "@client/content/controls/Image/container";
import { RedirectLinkEntity } from "@client/content/controls/Link/Redirect/container";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";

import "./style.less";

export type ImageComponentProps = RootContainerProps & {
  imageSrc: string;
  alt?: string;
};

const STYLE: React.CSSProperties = {
  width: "fit-content"
};
export default (props: ImageComponentProps) => {
  return (
    <TextContainer {...getContainerProps(props)} style={STYLE}>
      <RedirectLinkEntity {...getEntityRef(props)}>
        <ImageEntity {...getEntityRef(props)} src={props.imageSrc} alt={props.alt} />
      </RedirectLinkEntity>
    </TextContainer>
  );
};
